import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbCarouselConfig } from "@ng-bootstrap/ng-bootstrap";
import { OwlOptions, SlidesOutputData } from "ngx-owl-carousel-o";
import { UserService } from "src/app/services/user.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  activeSlides?: SlidesOutputData;
  getPassedData(data: SlidesOutputData) {
    this.activeSlides = data;
  }
  dynamicSlides = [
    {
      id: "1",
      src: "../../../../assets/Chp_images/profile_card/giftcentral_card.svg",
      alt: "Side 1",
      title: "Side 1",
      link: "https://www.paycentral.co.za/card/giftcentral/",
    },
    {
      id: "2",
      src: "../../../../assets/Chp_images/profile_card/giftcentral_plus_card.svg",
      alt: "Side 2",
      title: "Side 2",
      link: "https://www.paycentral.co.za/card/giftcentral-plus/",
    },
    {
      id: "3",
      src: "../../../../assets/Chp_images/profile_card/cashcentral_card.svg",
      alt: "Side 3",
      title: "Side 3",
      link: "https://www.paycentral.co.za/card/cashcentral/",
    },
    {
      id: "4",
      src: "../../../../assets/Chp_images/profile_card/cashcentral_plus_card.svg",
      alt: "Side 4",
      title: "Side 4",
      link: "https://www.paycentral.co.za/card/cashcentral-plus/",
    },
    {
      id: "5",
      src: "../../../../assets/Chp_images/profile_card/digicentral_card.svg",
      alt: "Side 5",
      title: "Side 5",
      link: "https://www.paycentral.co.za/card/digicentral/",
    },
    {
      id: "6",
      src: "../../../../assets/Chp_images/profile_card/fuelcentral_card.svg",
      alt: "Side 6",
      title: "Side 6",
      link: "https://www.paycentral.co.za/downloads/documents/FuelCentral.pdf",
    },
    {
      id: "7",
      src: "../../../../assets/Chp_images/profile_card/beyondcentral_card.svg",
      alt: "Side 7",
      title: "Side 7",
      link: "https://www.paycentral.co.za/card/beyondcentral/",
    },
  ];

  currentYear = new Date().getFullYear();
  appVersion: any;
  images: { imagePath: string }[];
  gamesFormatted: any[];
  show: boolean = false;
  loginForm: FormGroup;

  constructor(
    private userService: UserService,
    config: NgbCarouselConfig,
    private router: Router
  ) {
    config.interval = 5000;
    config.keyboard = true;
    config.pauseOnHover = true;
  }

  customOptions: OwlOptions = {
    loop: true,
    autoplay: true,
    autoplayHoverPause: false,
    autoplayTimeout: 2000,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 600,
    nav: true,
    navText: ["", ""],
    responsive: {
      0: {
        items: 3,
      },
      400: {
        items: 3,
      },
      760: {
        items: 4,
      },
      1000: {
        items: 7,
      },
    },
  };

  ngOnInit(): void {
    this.get();
  }

  get() {
    this.images = [
      {
        imagePath:
          "../../../../assets/Chp_images/card_use_company_logo/smar.svg",
      },
      {
        imagePath:
          "../../../../assets/Chp_images/card_use_company_logo/travelstart.svg",
      },
      {
        imagePath:
          "../../../../assets/Chp_images/card_use_company_logo/steers.svg",
      },
      {
        imagePath: "../../../../assets/Chp_images/card_use_company_logo/nu.svg",
      },
      {
        imagePath:
          "../../../../assets/Chp_images/card_use_company_logo/burgerlogo.svg",
      },
      {
        imagePath:
          "../../../../assets/Chp_images/card_use_company_logo/nandos.svg",
      },
      {
        imagePath:
          "../../../../assets/Chp_images/card_use_company_logo/stars.svg",
      },
    ];
    this.gamesFormatted = [];
    var j = -1;

    for (var i = 0; i < this.images.length; i++) {
      if (i % 3 == 0) {
        j++;
        this.gamesFormatted[j] = [];
        this.gamesFormatted[j].push(this.images[i]);
      } else {
        this.gamesFormatted[j].push(this.images[i]);
      }
    }
  }

  geturl(url) {
    window.open(url, "_blank");
  }



  
}
